"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const buttons_1 = require("../../atoms/buttons");
const react_i18next_1 = require("react-i18next");
const EmptyDiv = styled_components_1.default.div `
  height: 36px;
`;
const Header = ({ onBack, onMarkAsRead, disabled }) => {
    const [t] = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(MessagesHeader, { children: [onBack && ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["far", "arrow-left"], onClick: onBack }, void 0)), onMarkAsRead ? ((0, jsx_runtime_1.jsx)(buttons_1.Button, { onClick: onMarkAsRead, variant: "tertiary", disabled: disabled, children: t("chat.conversation.markAsRead") }, void 0)) : ((0, jsx_runtime_1.jsx)(EmptyDiv, { className: "empty-div" }, void 0))] }, void 0));
};
exports.Header = Header;
const MessagesHeader = styled_components_1.default.div `
  padding: 1rem;
  font-weight: 500;
  div {
    margin-top: 0.5rem;
    cursor: pointer;
    font-size: 1.25rem;
  }
  button {
    display: inline-block;
    width: auto;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    button {
      float: right;
      font-weight: 500;
    }
  }
`;
//# sourceMappingURL=Header.js.map